import { render, staticRenderFns } from "./VehicleOnPoiReport.vue?vue&type=template&id=32e05f4a&"
import script from "./VehicleOnPoiReport.vue?vue&type=script&lang=js&"
export * from "./VehicleOnPoiReport.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOnPoiReport.vue?vue&type=style&index=0&id=32e05f4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports